module.exports = __webpack_public_path__ + "static/media/Portrait-10264.adeb6d86.jpg";